var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-content"},[_c('h3',[_vm._v("¡Nueva versión disponible!")]),_c('p',[_vm._v("Por favor, actualiza la página para obtener la última versión.")]),_c('button',{on:{"click":_vm.refreshPage}},[_vm._v("Actualizar ahora")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }